import { create } from "zustand"
import { subscribeWithSelector } from "zustand/middleware"

export default create(subscribeWithSelector((set) =>
{
    return {

        phase: 'standard',
        touch: 'false',
        infoPanel: 'null',

        reset: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p1')
                        var pan2 = document.getElementById('p2')
                        var pan3 = document.getElementById('p3')
                        var pan4 = document.getElementById('p4')
                        var pan5 = document.getElementById('p5')

                        if (pan1.classList.contains('show'))
                            {
                                pan1.classList.add('hide')
                            }
                        pan1.classList.remove('show')
                        
                        if(pan2.classList.contains('show'))
                            {
                                pan2.classList.add('hide')
                            }
                        pan2.classList.remove('show')

                        if (pan3.classList.contains('show'))
                            {
                                pan3.classList.add('hide')
                            }
                        pan3.classList.remove('show')
                        
                        if(pan4.classList.contains('show'))
                            {
                                pan4.classList.add('hide')
                            }
                        pan4.classList.remove('show')

                        if (pan5.classList.contains('show'))
                            {
                                pan5.classList.add('hide')
                            }
                        pan5.classList.remove('show')
                
                    
                    return { infoPanel: 'null' }
                    }
                })
                
            },



        zoom: ()=>
            {
                set((state)=>
                {
                    if(state.phase === 'standard')
                        {
                            console.log('zooming in')
                            return { phase: 'zoomed' }
                            
                        }

                    if(state.phase === 'zoomed')
                        {
                            console.log('zooming out')
                            return { phase: 'standard' } 
                        }
                          
                    return {}
                })
            },


        touched: ()=>
            {
                set((state)=>
                {   
                    
                        {
    
                            return { touch: 'true' }       
                        }
                              
    
                    
                })
            },

        p1: ()=>
            {
                set((state)=>
                {
                    {
                        state.reset()
                        var panel = document.getElementById('p1')
                        panel.classList.remove('hide')
                        panel.classList.add('show')
    
                        return { infoPanel: '1' }
                    }
                })
                
            },

        p2: ()=>
            {
                set((state)=>
                {
                    {
                        state.reset()
                        var panel = document.getElementById('p2')
                        panel.classList.remove('hide')
                        panel.classList.add('show')
    
                        return { infoPanel: '2' }
                    }
                })
                
            },

        p3: ()=>
            {
                set((state)=>
                {
                    {
                        state.reset()
                        var panel = document.getElementById('p3')
                        panel.classList.remove('hide')
                        panel.classList.add('show')
    
                        return { infoPanel: '3' }
                    }
                })
                
            },

        p4: ()=>
            {
                set((state)=>
                {
                    {
                        state.reset()
                        var panel = document.getElementById('p4')
                        panel.classList.remove('hide')
                        panel.classList.add('show')
    
                        return { infoPanel: '4' }
                    }
                })
                
            },

        p5: ()=>
            {
                set((state)=>
                {
                    {
                        state.reset()
                        var panel = document.getElementById('p5')
                        panel.classList.remove('hide')
                        panel.classList.add('show')
    
                        return { infoPanel: '5' }
                    }
                })
                
            },

        p6: ()=>
            {
                set((state)=>
                {
                    {
                        state.reset()
                        var panel = document.getElementById('p6')
                        panel.classList.remove('hide')
                        panel.classList.add('show')
    
                        return { infoPanel: '6' }
                    }
                })
                
            },

        p7: ()=>
            {
                set((state)=>
                {
                    {
                        state.reset()
                        var panel = document.getElementById('p7')
                        panel.classList.remove('hide')
                        panel.classList.add('show')
    
                        return { infoPanel: '7' }
                    }
                })
                
            },
    }
}))